import { getStorage, ref, deleteObject } from "firebase/storage";
import { doc, getDoc, deleteDoc } from "firebase/firestore";
import Cookies from "js-cookie";
import { db } from "../firebase";

export const deleteFileByUid = async (fileuid,servicetablename) => {
  if (!fileuid) return { success: false, error: "Missing file UID" };

  try {
    const companyuid = Cookies.get("select_company_uid");
    if (!companyuid) {
      return { success: false, error: "Company UID missing" };
    }

    // Correct Firestore path: companies/{company}/files/{fileuid}
    const fileDocRef = doc(db, servicetablename, companyuid, "files", fileuid);
    const fileSnap = await getDoc(fileDocRef);

    if (!fileSnap.exists()) {
      return { success: false, error: "File record not found in Firestore" };
    }

    const fileData = fileSnap.data();
    const fileUrl = fileData?.url;

    if (!fileUrl) {
      return { success: false, error: "File URL missing in record" };
    }

    const storage = getStorage();
    let fileRef;

    const baseUrl = "https://firebasestorage.googleapis.com/v0/b/";

    if (fileUrl.startsWith(baseUrl)) {
      // Extract storage path from Firebase download URL
      const part = fileUrl.split("/o/")[1]?.split("?")[0];
      if (!part) {
        return { success: false, error: "Invalid Firebase download URL" };
      }
      fileRef = ref(storage, decodeURIComponent(part));
    } else {
      // Already a storage path
      fileRef = ref(storage, fileUrl);
    }

    // Delete file from Storage
    await deleteObject(fileRef);

    // Delete Firestore record
    await deleteDoc(fileDocRef);

    return { success: true };
  } catch (err) {
    return { success: false, error: err.message || err };
  }
};
